import React from 'react';
import CreateClassroomModalForm from './components/CreateClassroomModalForm';
import { ProductCardValidationProvider } from 'components/@common/ProductLicenses/product-card-validation-provider';

interface CreateClassroomModalProps {
  onClose: Function;
  step?: number;
}

const CreateClassroomModal = (props: CreateClassroomModalProps) => (
  <ProductCardValidationProvider>
    <CreateClassroomModalForm {...props} />
  </ProductCardValidationProvider>
);

export default CreateClassroomModal;
